import { render, staticRenderFns } from "./company-complete-card.vue?vue&type=template&id=654c521d&"
import script from "./company-complete-card.vue?vue&type=script&lang=js&"
export * from "./company-complete-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports